import { SVGIconProps } from './types/types';

const Call = ({ width = 16, height = 16 }: SVGIconProps) => (
  <svg
    focusable={false}
    height={height}
    viewBox='0 0 16 16'
    width={width}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='m4.83590597 11.164064c-1.27860378-1.27861578-2.30064176-2.81205578-3.06611394-4.60032001-.53765566-1.256039-.25677282-2.7128554.70932189-3.67895917l1.1400178-1.14002848c.32633872-.32634179.85543834-.32634179 1.18177707 0 .04690211.04690256.08805317.09922262.12258429.15585546l1.6850785 2.76361739-1.39838915 1.39840016c-.23605445.23605667-.30896792.58995789-.18544531.9000988.37278617.93599254.90073099 1.74554375 1.58383446 2.42865362.68309629.68310273 1.49263008 1.21104853 2.42860136 1.58383753l-.00000944.0000237c.31014755.123529.66405724.0506132.90011935-.1854511l1.39839695-1.39841013 2.7635915 1.68509433c.3940402.2402652.5187013.7544742.2784383 1.1485181-.0345311.0566328-.0756822.1089529-.1225843.1558555l-1.140017 1.1400274c-.9660933.9661023-2.4228938 1.2469876-3.67892081.7093316-1.78824946-.7654796-3.32167663-1.7875278-4.60028152-3.0661447z'
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default Call;
